import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import backgroundImage from "./HeaderSlider_02.jpg"; // Vérifie le chemin
import {
  registerTeacher,
  validateInvitation,
} from "../../services/invitationServices";

function TeacherRegisterPage() {
  const { token } = useParams(); // 🔥 Récupération du token
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [clubName, setClubName] = useState(""); // Ajout du club pour affichage
  const [errorMessage, setErrorMessage] = useState("");

  // 📌 Vérifier si le token est valide et récupérer les infos
  useEffect(() => {
    const fetchInvitation = async () => {
      const data = await validateInvitation(token);
      if (data) {
        setEmail(data.email);
        setClubName(data.club_name); // Ajoute le nom du club pour affichage
      } else {
        setErrorMessage("Invitation invalide ou expirée.");
      }
    };
    fetchInvitation();
  }, [token]);

  // 📌 Inscription de l'enseignant
  // 📌 Inscription de l'enseignant
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      setErrorMessage("Token invalide ou inexistant.");
      return;
    }

    if (!password) {
      setErrorMessage("Veuillez choisir un mot de passe.");
      return;
    }

    console.log("✅ Token envoyé :", token); // 🔥 Ajoute cette ligne pour debugger

    const result = await registerTeacher(token, password);
    if (result) {
      alert("Votre compte a été créé avec succès !");
      navigate("/login");
    } else {
      setErrorMessage("Erreur lors de l'inscription.");
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
      }}
    >
      <div className="max-w-md w-full space-y-8 bg-white bg-opacity-90 p-10 rounded-lg shadow-lg">
        {errorMessage && (
          <div className="alert alert-error shadow-lg">
            <div>
              <span>{errorMessage}</span>
            </div>
          </div>
        )}
        <form onSubmit={handleSubmit} className="space-y-6">
          <h1 className="text-center text-3xl font-bold">
            Inscription Enseignant
          </h1>
          <p className="text-center text-gray-700">
            Vous avez été invité par le club : <strong>{clubName}</strong>
          </p>
          <div className="form-control w-full">
            <label className="label">
              <span className="label-text">Email</span>
            </label>
            <input
              type="email"
              className="input input-bordered w-full"
              value={email}
              disabled // 🔥 Désactivé car lié à l'invitation
            />
          </div>
          <div className="form-control w-full">
            <label className="label">
              <span className="label-text">Mot de passe</span>
            </label>
            <input
              type="password"
              placeholder="Choisissez un mot de passe"
              className="input input-bordered w-full"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button
            className="w-full bg-primary text-white px-4 py-2 rounded-md shadow-sm transition duration-300 ease-in-out hover:bg-white hover:text-primary border border-primary flex items-center justify-center"
            type="submit"
          >
            S'inscrire
          </button>
        </form>
      </div>
    </div>
  );
}

export default TeacherRegisterPage;
